<template>
  <div class="body">
    <el-container>
      <!-- <ProductsAside /> -->
      <el-main>
        <button
          v-show="1 == 0"
          v-shortkey="['f3']"
          @shortkey="showHiden = !showHiden"
        ></button>
        <div class="mb-5">
          <el-row :gutter="10">
            <el-col :xl="4" :lg="5" :md="6" :sm="12">
              <div class="bg-White p-3">
                <el-input
                  @change="filterProducts"
                  placeholder="بحث باسم المنتج"
                  autofocus
                  type="text"
                  @focus="$event.target.select()"
                  v-model="name"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="6" :sm="12">
              <div class="bg-White p-3">
                <el-select
                  multiple
                  v-model="selectedCategory"
                  clearable
                  placeholder="بحث بالتصنيف"
                  @change="filterProducts"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in productCategories"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="4" :sm="12">
              <div class="bg-White p-3">
                <el-input
                  @keyup.enter.native="filterProducts"
                  placeholder="بحث بالباركود"
                  autofocus
                  type="text"
                  @focus="$event.target.select()"
                  v-model="searchCode"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="5" :sm="8">
              <div class="bg-White p-3">
                <el-select
                  @change="filterByStock"
                  v-model="stock"
                  clearable
                  placeholder="حدد المخزون"
                  style="width: 100%"
                >
                  <el-option label="عرض الكل" value=""> </el-option>
                  <el-option label="أكبر من الصفر" value="1"> </el-option>
                  <el-option label="غير متاح" value="0"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :lg="4">
              <div class="bg-White p-3">
                <el-select
                  @change="filterByUntis"
                  v-model="units"
                  clearable
                  placeholder="الوحدات"
                  style="width: 100%"
                >
                  <el-option label="كل الوحدات" value=""> </el-option>
                  <el-option label="الوحدات الرئيسيه" value="1"> </el-option>
                  <el-option label="الوحدات الفرعيه" value="2"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :lg="3" :md="3" :sm="4">
              <div class="bg-White p-3" style="text-align: center">
                <el-row :gutter="5">
                  <el-col :span="12">
                    <el-button
                      type="success"
                      @click="printAllProducts"
                      icon="el-icon-printer"
                    ></el-button>
                  </el-col>
                  <el-col :span="12">
                    <JsonExcel
                      :fields="excelFields"
                      :data="tableData"
                      class="el-button el-button--warning el-button--mini"
                      title="إستخراج لاكسل"
                      ><i class="fa fa-file-excel fa-2x"></i
                    ></JsonExcel>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <!-- <el-col :lg="2">
              <div class="bg-White p-3" style="text-align: center">
              </div>
            </el-col> -->
          </el-row>
        </div>
        <div v-if="showHiden">
          <el-button type="success">
            بالشراء |

            {{ sumBuyCost }}</el-button
          >
          <el-button type="primary" class="mr-2">
            بالبيع |
            {{ sumSaleCost }}</el-button
          >
          <el-button type="warning" class="mr-2 mt-2">
            الربح |
            {{ numberToFixed(sumSaleCost - sumBuyCost) }}</el-button
          >
        </div>
        <el-table
          style="overflow: auto"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
        >
          <!-- style="width: 100%" -->
          <!-- <el-table-column label="#" type="index" width="50"> </el-table-column> -->
          <el-table-column
            sortable
            width="130"
            prop="code"
            label="الكود"
          ></el-table-column>
          <el-table-column
            width="220"
            label="اسم المنتج"
            prop="product.name"
          ></el-table-column>
          <el-table-column
            label="سعر البيع"
            prop="sale_price"
          ></el-table-column>
          <el-table-column
            label="التصنيف"
            prop="product.product_category.name"
          ></el-table-column>
          <el-table-column
            label="حد الطلب"
            prop="product.inventories[0].pivot.min_threshold"
          ></el-table-column>
          <el-table-column
            label="الوحدات"
            prop="product.units_per_package"
          ></el-table-column>
          <el-table-column sortable label="المخزون">
            <template slot-scope="scope">
              <span>{{ scope.row.stock }}</span> -
              <span>{{ scope.row.unit }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column sortable label="الفرعية">
            <template slot-scope="scope">
              <span v-if="scope.row.inventories > 0">{{
                scope.row.inventories[0].pivot.qty -
                scope.row.inventories[0].pivot.hold_qty
              }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="اجراءات" width="110">
            <template slot-scope="scope">
              <el-row :gutter="5">
                <el-col :span="12" v-if="accessLinks('update_product')">
                  <el-button
                    type="warning"
                    title="تعديل"
                    icon="el-icon-edit"
                    @click="edit(scope)"
                    size="mini"
                  ></el-button>
                </el-col>
                <el-col
                  :span="12"
                  v-if="accessLinks('delete_product') && scope.row.type == 1"
                >
                  <el-popconfirm
                    confirm-button-text="موافق"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="'هل تريد حذف ' + ' ' + scope.row.product.name + ' ؟'"
                    @confirm="deleteItem(scope.row.product_id)"
                  >
                    <el-button
                      slot="reference"
                      type="danger"
                      title="مسح"
                      icon="el-icon-delete"
                      size="mini"
                    ></el-button>
                  </el-popconfirm>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <!-- <el-table-column type="expand">
      <template slot-scope="props">
        <p>State: {{ props.row.name }}</p>

      </template>
    </el-table-column> -->
        </el-table>
        <el-row>
          <el-col :span="24">
            <el-button
              style="width: 100%"
              v-if="tableData.length > 0 && pagination.last_page > 1"
              @click="loadMoreData"
              icon="el-icon-caret-bottom"
              >تحميل المزيد</el-button
            >
          </el-col>
        </el-row>
        <el-dialog

          title="تعديل بيانات المنتج"
          :visible.sync="editFormVisible"
          v-if="selectedProduct"
        >
          <el-form :model="selectedProduct">
            <el-row :gutter="10">
              <el-col :xl="8" :lg="8" :md="6" :sm="12">
                <el-form-item label="اسم المنتج">
                  <el-input
                    v-model="selectedProduct.name"
                    autocomplete="off"
                    @focus="$event.target.select()"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="4" :lg="4" :md="6" :sm="12">
                <el-form-item label="حدد الطلب ">
                  <input
                    class="form-control"
                    v-model="selectedProduct.inventories[0].pivot.min_threshold"
                    autocomplete="off"
                    @focus="$event.target.select()"
                  />
                </el-form-item>
              </el-col>
              <el-col :xl="4" :lg="4" :md="6" :sm="12">
                <el-form-item label="سعر الجملة">
                  <el-input
                    v-model="selectedProduct.prices[0].sale_price"
                    autocomplete="off"
                    type="number"
                    @focus="$event.target.select()"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="4" :lg="4" :md="6" :sm="12">
                <el-form-item label="سعر جملة الجملة">
                  <el-input
                    v-model="selectedProduct.prices[0].wholesale_price"
                    autocomplete="off"
                    type="number"
                    @focus="$event.target.select()"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="4" :lg="4" :md="6" :sm="12">
                <el-form-item label="الكود ">
                  <el-input
                    v-model="selectedProduct.prices[0].code"
                    autocomplete="off"
                    @focus="$event.target.select()"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="4" :lg="4" :md="6" :sm="12">
                <el-form-item label="الوحدة ">
                  <el-input
                    v-model="selectedProduct.prices[0].unit"
                    autocomplete="off"
                    @focus="$event.target.select()"
                  ></el-input>
                </el-form-item>
              </el-col>
              <template v-if="selectedProduct.prices.length > 1">
                <el-card shadow="never">
                  <div slot="header" class="clearfix">
                    <span>الوحدة الفرعية</span>
                  </div>
                  <el-col :xl="5" :lg="5" :md="12" :sm="12">
                    <el-form-item label="سعر الجملة">
                      <el-input
                        v-model="selectedProduct.prices[1].sale_price"
                        autocomplete="off"
                        type="number"
                        @focus="$event.target.select()"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xl="5" :lg="5" :md="12" :sm="12">
                    <el-form-item label="سعر جملة الجملة">
                      <el-input
                        v-model="selectedProduct.prices[1].wholesale_price"
                        autocomplete="off"
                        type="number"
                        @focus="$event.target.select()"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xl="5" :lg="5" :md="12" :sm="12">
                    <el-form-item label="الكود ">
                      <el-input
                        v-model="selectedProduct.prices[1].barcode"
                        autocomplete="off"
                        @focus="$event.target.select()"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xl="5" :lg="5" :md="12" :sm="12">
                    <el-form-item label="الوحدة ">
                      <el-input
                        v-model="selectedProduct.prices[1].unit"
                        autocomplete="off"
                        @focus="$event.target.select()"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="12" :sm="12">

                    <el-button class="mt-2" type="danger" @click="removeUnit">
                      <i class="fas fa-trash-alt"></i
                    ></el-button>
                  </el-col>
                </el-card>
              </template>
              <div
                v-if="selectedProduct.prices.length == 1"
              >

                <el-button class="mt-5" type="warning" @click="addNewUnit">
                  اضافة وحدة فرعية</el-button
                >
              </div>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="update">حفظ التعديلات</el-button>
            <el-button class="mr-3" @click="editFormVisible = false"
              >إلغاء</el-button
            >
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import ProductsAside from "@/components/ProductsAside.vue";
// import { ipcRenderer } from "electron";
import JsonExcel from "vue-json-excel";

export default {
  name: "Products",
  components: {JsonExcel },
  data() {
    return {
      showHiden: false,
      sumBuyCost: 0,
      sumSaleCost: 0,
      stock: "",
      editFormVisible: false,
      tableData: [],
      allData: [],
      selectedProduct: null,
      productCategories: [],
      name: "",
      searchCode: "",
      selectedCategory: "",
      units: "",
      current_page: 1,
      page_limit: 1,
      activeSide: true,
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      excelFields: {
        الاسم: "product.name",
        البيع: "sale_price",
        الكود: "code",
        المخزون: "stock",
        الوحده: "unit",
      },
      filterMode: false,
    };
  },
  created() {
    this.getProducts();
    this.getCategories();
    // axiosApi.get("products/filter/unit?page=1&limit=50").then((res)=>{
    //   console.log("filter",res);
    // })
  },
  //     mounted(){
  //      window.onscroll = () => {
  //     let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight > (document.documentElement.offsetHeight-500)

  //     if (bottomOfWindow) {

  //       // alert("get more data")
  //        if( this.pagination.last_page > this.pagination.current_page){
  //        this.pagination.current_page++;
  //      this.getProducts()
  //        }
  //     }
  //  }
  //     },
  methods: {
    async getProductsCost() {
      // let loader = this.$loading.show({});
      let link = `products-cost?limit=20`;
      if (this.name.trim() != "") {
        link += "&name=" + this.name;
      }
      if (this.searchCode.trim() != "") {
        link += "&code=" + this.searchCode;
      }
      if (this.selectedCategory != null && this.selectedCategory != "") {
        link += "&category_id=" + this.selectedCategory;
      }
      await axiosApi
        .get(link)
        .then((res) => {
          this.sumBuyCost = this.numberToFixed(res.data[0].sumBuyCost);
          this.sumSaleCost = this.numberToFixed(res.data[0].sumSaleCost);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          // loader.hide();
        });
    },
    filterByStock() {
      this.tableData = this.allData;

      if (this.stock != "") {
        if (this.stock == 0) {
          this.tableData = this.tableData.filter((item) => {
            if (item.stock == 0) {
              return item;
            }
          });
        } else if (this.stock == 1) {
          this.tableData = this.tableData.filter((item) => {
            if (item.stock > 0) {
              return item;
            }
          });
        }
      } else {
        this.tableData = this.allData;
      }
    },
    edit(product) {
      this.selectedProduct = product.row.product;
      this.editFormVisible = true;
      // rows.splice(index, 1);
    },
    addNewUnit() {
      this.selectedProduct.prices.push({
        barcode: null,
        code: null,
        wholesale_price: "",
        sale_price: "",
        fatura_price: "",
        unit: "",
        min_price: "",
        type: 2,
        id: 0,
      });
    },
    removeUnit() {
      this.selectedProduct.prices.splice(1, 1);
    },
    loadMoreData() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getProducts();
      }
    },
    getProducts() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.filterMode) {
        this.pagination.current_page = 1;
        this.tableData = [];
      }
      // this.getProductsCost();
      let url = `products/filter/unit?page=${this.pagination.current_page}&limit=50`;
      if (this.units != "") {
        url += `&type=${this.units}`;
      }
      axiosApi
        .get(url)
        .then((res) => {
          console.log("getProducts", res.data);
          res.data.data.map((item) => {
            this.tableData.push(item);
          });
          this.pagination = res.data.meta;
          this.tableData.map((product) => {
            if (product.type == 1) {
              product.stock = this.numberToFixed(
                (product.product.inventories[0].pivot.qty -
                  product.product.inventories[0].pivot.hold_qty) /
                  product.product.units_per_package
              );
            } else {
              product.stock = this.numberToFixed(
                product.product.inventories[0].pivot.qty -
                  product.product.inventories[0].pivot.hold_qty
              );
            }
            product.min_threshold = Number(
              product.product.inventories[0].pivot.min_threshold
            );
          });
          this.tableData = this.tableData.filter((product) => {
            return product.product.prices.length > 0;
          });
          this.allData = this.tableData;
          this.filterByStock();
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
          this.filterMode = false;
        });
    },
    filterProducts() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.getProductsCost();
      this.tableData = [];
      let url = `products/filter/unit?page=1&limit=50`;
      if (this.name.trim() != "") {
        url += "&name=" + this.name;
      }
      if (this.searchCode.trim() != "") {
        url += "&code=" + this.searchCode;
      }
      if (this.selectedCategory != "") {
        url += "&category_id=" + this.selectedCategory;
      }
      axiosApi
        .get(url)
        .then((res) => {
          res.data.data.map((item) => {
            this.tableData.push(item);
          });
          this.pagination = res.data.meta;
          this.tableData.map((product) => {
            if (product.type == 1) {
              product.stock = this.numberToFixed(
                (product.product.inventories[0].pivot.qty -
                  product.product.inventories[0].pivot.hold_qty) /
                  product.product.units_per_package
              );
            } else {
              product.stock = this.numberToFixed(
                product.product.inventories[0].pivot.qty -
                  product.product.inventories[0].pivot.hold_qty
              );
            }
            product.min_threshold = Number(
              product.product.inventories[0].pivot.min_threshold
            );
          });
          this.tableData = this.tableData.filter((product) => {
            return product.product.prices.length > 0;
          });
          this.allData = this.tableData;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    filterByUntis() {
      this.filterMode = true;
      this.getProducts();
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    update() {
      const loading = this.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
      });
      this.selectedProduct["stock"] =
        this.selectedProduct.inventories[0].pivot.qty /
        this.selectedProduct.units_per_package;
      this.selectedProduct[
        "min_threshold"
      ] = this.selectedProduct.inventories[0].pivot.min_threshold;
      axiosApi
        .put(`products/${this.selectedProduct.id}`, this.selectedProduct)
        .then(() => {
          this.getProducts();
          this.editFormVisible = false;
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم تحديث بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          // this.$message.error('Oops, this is a error message.');
          // console.log(e.response.data)
          // if(e.response.message)
          if (e.response.data.barcode) {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من عدم تكرار كود المنتج  ",
              duration: 1500,
            });
          } else {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من بيانات المطلوبة",
              duration: 1500,
            });
          }
          console.log(e);
        })
        .finally(() => loading.close());
    },
    deleteItem(product_id) {
      const loading = this.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .delete(`products/${product_id}`)
        .then(() => {
          this.filterMode = true;
          this.getProducts();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم مسح بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
          console.log(e);
        })
        .finally(() => loading.close());
    },
    getCategories() {
      axiosApi
        .get("product-categories")
        .then((res) => {
          this.productCategories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    printAllProducts() {
      // window.ipcRenderer = ipcRenderer;
      // let search = "";
      // if (this.name !== "") {
      //   search = this.name;
      // } else if (this.searchCode !== "") {
      //   search = +this.searchCode;
      // }
      // let data = {
      //   data: this.tableData,
      //   type: "productsReport",
      //   searchKey: search,
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>
<style scoped>
.el-table {
  width: 100%;
  max-height: 80%;
  overflow-y: scroll;
}
</style>
